import React, { useCallback, useState } from 'react';
import { Popover } from 'antd';
import ModuleIcon from '@components/moduleIcon';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import '@style/components/moduleNavigationPopover.scss';
import '../../styles/components/moduleNavigationPopover.scss';
import { addProtocolToLink } from '@utils/common';

export const ModuleList = ({ routes, close, history, projectId }) => {
  const goto = useCallback(
    ({ to, isExternal, iframe, type, menuId }) => {
      if (projectId && to.startsWith('/projects/setting')) {
        close();
        history.push(to, {
          from: history.location.pathname + history.location.search,
        });
        return;
      }
      if (isExternal && !iframe) {
        try {
          window.open(addProtocolToLink(to));
        } catch (e) {
          window.open('Invalid website');
        }
      } else {
        close();
        menuId ? history.push(to, { menuId }) : history.push(to);
        window.scrollTo(0, 0);
      }
    },
    [projectId],
  );

  return routes ? (
    <div>
      {routes?.map((r, i) => (
        <div
          className="p-list-item module_navigation_items"
          key={`p-item-${i}`}
          to={r.to}
          onClick={() => goto(r)}
        >
          <div className="module_navigation_icon">
            {r.iconId ? <ModuleIcon type={r.iconId} /> : null}
          </div>
          <div className="text-ellipsis">{r.displayName}</div>
        </div>
      ))}
    </div>
  ) : null;
};

export const ModuleNavigationPopover = ({ routes, keyName: key }) => {
  const isActive = routes.some((e) => !e.isExternal && e.isActive);
  const history = useHistory();
  const projectId = useSelector((state) => state.common.currentId);

  const [clicked, click] = useState(false);

  const close = () => click(false);

  if (routes.length === 0) {
    return null;
  }

  const isButtonActive = Boolean(isActive || clicked);

  return (
    <Popover
      placement="rightBottom"
      content={
        <ModuleList
          close={close}
          routes={routes}
          projectId={projectId}
          history={history}
        />
      }
      trigger="hover"
      overlayClassName="module-nav-popover_mod_settings"
      visible={clicked}
      onVisibleChange={click}
      destroyTooltipOnHide
      getPopupContainer={() => document.querySelector(`.app-container`)}
      getTooltipContainer={() => document.querySelector(`.app-container`)}
      // getPopupContainer={() =>
      //   document.querySelector('.last-nav-item') || document.body
      // }
    >
      <div
        className={`nav-bar-item ${
          isButtonActive && 'is-active'
        } last-nav-item`}
        key={`sider-nav-item-${key}`}
        style={{ position: 'relative' }}
      >
        <li>
          <div className="icon-wrapper">
            <span
              className={`appkiticon a-font-24 icon-grid-view-${
                isButtonActive ? 'fill' : 'outline'
              }`}
            />
          </div>
          <div className={`siderbar-name ${isButtonActive && 'is-active'}`}>
            Module Navigation
          </div>
        </li>
      </div>
    </Popover>
  );
};

// export default ModuleNavigationPopover;
